import HomePageHandler from "./HomePageHandler";
import ApplicationDetailPageHandler from "./ApplicationDetailPageHandler";
import ApplicationsListPageHandler from "./ApplicationsListPageHandler";
import CustomerDetailPageHandler from "./CustomerDetailPageHandler";
import CustomersListPageHandler from "./CustomersListPageHandler";
import LicenseDetailPageHandler from "./LicenseDetailPageHandler";
import LicensesListPageHandler from "./LicensesListPageHandler";
import LicensesInUseListPageHandler from "./LicensesInUseListPageHandler";
import UserDetailPageHandler from "./UserDetailPageHandler";
import UsersListPageHandler from "./UsersListPageHandler";
import LogsPageHandler from "./LogsPageHandler";
import OfflineLicensesInUseListPageHandler from "./OfflineLicensesInUseListPageHandler";
import OfflineLicensesInUseDetailPageHandler from "./OfflineLicensesInUseDetailPageHandler";

export default [
  new HomePageHandler(),
  new ApplicationDetailPageHandler(),
  new ApplicationsListPageHandler(),
  new CustomerDetailPageHandler(),
  new CustomersListPageHandler(),
  new LicenseDetailPageHandler(),
  new LicensesListPageHandler(),
  new LicensesInUseListPageHandler(),
  new UserDetailPageHandler(),
  new UsersListPageHandler(),
  new LogsPageHandler(),
  new OfflineLicensesInUseListPageHandler(),
  new OfflineLicensesInUseDetailPageHandler()
];



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/index.js